import React, { useEffect, useMemo, useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';
import './categorywise.css'
import AOS from "aos";
import "aos/dist/aos.css";
import Modal from '../Modal';
import { logAudioClick, SECTIONS } from '../../utils/contentConsumption';
import { useKeenSlider } from 'keen-slider/react';
const CategoryWiseFiles = ({ audiofiles, categories }) => {
    const navigate = useNavigate()
    const openAudioFile = (audio_file_id) => {
        logAudioClick(audio_file_id, SECTIONS.HOME_CATEGORY);
        navigate(`/audio-file-detail/${audio_file_id}`);
    };
    useEffect(() => {
        /*    AOS.init({
               disable: "phone",
               duration: 700,
               easing: "zoom-in-up",
           }); */
    }, []);
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    const [dw, setWidth] = useState(0)
    useEffect(() => {
        const w = window.innerWidth
        setWidth(w)
    })
    const user_id = localStorage.getItem('dastaan__user_id') !== null ? localStorage.getItem('dastaan__user_id') : null
    const plan_active = localStorage.getItem('dastaan__plan_active');
    const CustomNextArrow = ({ onClick }) => (
        <button className="custom-next-arrow" onClick={onClick}>
            {/* <FontAwesomeIcon aria-hidden="true" icon={faAngleRight} /> */}
        </button>
    );
    const CustomPrevArrow = ({ onClick }) => (
        <button className="custom-prev-arrow" onClick={onClick}>
            {/* <FontAwesomeIcon aria-hidden="true" icon={faAngleLeft} /> */}
        </button>
    );
    // useMemo keep setting in memory for high performance
    const settings = useMemo(() => ({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: "ease-in-out",
        swipeToSlide: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            }
        ]
    }), []);
    const [sliderRef] = useKeenSlider({
        loop: true,
        mode: "free-snap",
        slides: {
            perView: 12,
            spacing: 15,
        },
        breakpoints: {
            "(max-width: 1200px)": {
                slides: {
                    perView: 5,
                    spacing: 15,
                },
            },
            "(max-width: 1024px)": {
                slides: {
                    perView: 5,
                    spacing: 15,
                },
            },
            "(max-width: 768px)": {
                slides: {
                    perView: 3,
                    spacing: 15,
                },
            },
            "(max-width: 600px)": {
                slides: {
                    perView: 3,
                    spacing: 10,
                },
            },
            "(max-width: 480px)": {
                slides: {
                    perView: 3,
                    spacing: 10,
                },
            },
        },
    })
    return (
        <div className={`slider-container-category  aos-animate aos-init ${dw > 768 ? 'ml-10' : ''}`}
        // data-aos="fade-up" data-aos-delay="100"
        >
            <>
                {/*  {
                    categories.map((category, index) => {
                        if (audiofiles[index].length > 0) {
                            return (
                                <div key={category.category_id} className='mt-2 aos-animate mb-3'
                                  data-aos="fade-up" 
                                      data-aos-delay="100"
                                      data-aos-duration="1000"
                                // data-aos="fade-up" data-aos-delay="100"
                                >
                                    <h3 className="home-heading mb-2">{category.category_name}</h3>
                                    <Slider {...settings}>
                                        {audiofiles[index].map((audFile) => {
                                            const hr = (audFile.duration / 3600).toFixed(2);
                                            const hrArr = hr.split('.');
                                            const min = (hrArr[1] / 60).toFixed(2);
                                            const minArr = min.split('.');
                                            const sec = parseInt(minArr[1]);
                                            return (
                                                <div key={audFile.audio_file_id} className="card-wrapper">
                                                    <div className="card" style={{ height: "120px" }}
                                                        // onClick={() => user_id !== null ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : setShowModal(true)}
                                                        onClick={() => (user_id !== null && plan_active === 'true') ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : (user_id !== null && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                                                    >
                                                        <div className='image'>
                                                            <img src={audFile.landscape_thumb}
                                                                loading="lazy"
                                                                alt={audFile.title} className="card-img-top slick-slider-img" />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </Slider>
                                </div>
                            );
                        }
                        return null;
                    })
                } */}
                {
                    categories.map((category, index) => {
                        if (audiofiles[index].length > 0) {
                            return (
                                <div key={category.category_id} className='mt-2 aos-animate mb-3'
                                
                                /*     data-aos="fade-up" 
                                      data-aos-delay="100"
                                      data-aos-duration="1000" */
                                // data-aos="fade-up" data-aos-delay="100"
                                >
                                    <h3 className="home-heading mb-2">{category.category_name}</h3>
                                    <div ref={sliderRef} className="keen-slider">
                                        {audiofiles[index].map((audFile) => {
                                            const hr = (audFile.duration / 3600).toFixed(2);
                                            const hrArr = hr.split('.');
                                            const min = (hrArr[1] / 60).toFixed(2);
                                            const minArr = min.split('.');
                                            const sec = parseInt(minArr[1]);
                                            return (
                                                <div className="keen-slider__slide" >
                                                    <div key={audFile.audio_file_id} className="card-wrapper">
                                                        <div className="card"
                                                            // onClick={() => user_id !== null ? navigate(`/audio-file-detail/${audFile.audio_file_id}`) : setShowModal(true)}
                                                            onClick={() => (user_id !== null && plan_active === 'true') ? (openAudioFile(audFile.audio_file_id)) : (user_id !== null && plan_active === 'false' ? navigate('/plans') : setShowModal(true))}
                                                        >
                                                            <div className='image'>
                                                                <img src={audFile.landscape_thumb}
                                                                    loading="lazy"
                                                                    alt={audFile.title} className="card-img-top slick-slider-img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        }
                        return null;
                    })
                }
                <Modal show={showModal} onClose={() => setShowModal(false)} />
            </>
        </div>
    );
};
export default React.memo(CategoryWiseFiles);
